import { __assign, __extends } from "tslib";
import * as React from 'react';
import { ButtonVariant_$type } from "./ButtonVariant";
import { IgrButtonBase } from "./igr-button-base";
import { Button } from "./Button";
import { IgcButtonComponent, defineComponents } from "igniteui-webcomponents";
import { isValidProp, ensureEnum } from "igniteui-react-core";
/**
 * Represents a clickable button, used to submit forms or anywhere in a
 * document for accessible, standard button functionality.
*/
var IgrButton = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrButton, _super);
    function IgrButton(props) {
        var _this = _super.call(this, props) || this;
        _this._getMainRef = _this._getMainRef.bind(_this);
        defineComponents(IgcButtonComponent);
        return _this;
    }
    IgrButton.prototype.createImplementation = function () {
        return new Button();
    };
    Object.defineProperty(IgrButton.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrButton.prototype.componentDidMount = function () {
        this.i.nativeElement = this._elRef;
        this.mounted = true;
        _super.prototype.componentDidMount.call(this);
    };
    IgrButton.prototype.render = function () {
        var _this = this;
        var nativePropsName = Object.keys(this.props).filter(function (prop) { return !isValidProp(_this, prop) && prop !== "originalRef"; });
        var nativeProps = {};
        nativePropsName.forEach(function (propName) {
            nativeProps[propName] = _this.props[propName];
        });
        var propChildren = this.props.children;
        var children = [];
        React.Children.forEach(propChildren, function (ch) {
            children.push(React.cloneElement(ch));
        });
        this._portalManager.onRender(children);
        var style = {};
        if (this.props.style) {
            style = this.props.style;
        }
        var div = React.createElement("igc-button", __assign(__assign({}, nativeProps), { ref: this._getMainRef, id: this.props.id, class: this.props.className, style: style, children: children }));
        return div;
    };
    IgrButton.prototype._getMainRef = function (ref) {
        this._elRef = ref;
    };
    Object.defineProperty(IgrButton.prototype, "variant", {
        /**
         * Sets the variant of the button.
        */
        get: function () {
            return this.i.v;
        },
        set: function (v) {
            this.i.v = ensureEnum(ButtonVariant_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrButton;
}(IgrButtonBase));
export { IgrButton };
